// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"styles_tabBar__2X3Jz","split":"styles_split__92uWZ","tab":"styles_tab__2sILP","active":"styles_active__1GtFo"};